import React, { useState, useCallback, useRef,useEffect } from 'react';
import {
    TextInput, Create, FormTab, TabbedForm, useGetOne, useRedirect,
    useNotify, Toolbar, SaveButton, useResourceContext, usePermissions
} from 'react-admin';
import MomentUtils from '@date-io/moment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import Select from 'react-select';
import { DateInput } from 'react-admin-date-inputs';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common'
import { Papa } from '../common/common';
import moment from 'moment';
// import CKEditor from '@ckeditor/ckeditor5-react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from 'sweetalert2';
import { useLocation ,useNavigate } from 'react-router-dom';
import {
    LocalizationProvider,
    DatePicker,
  } from "@mui/x-date-pickers";


class MyUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }
    // Starts the upload process.
    upload() {
        return null
        return this.loader.file.then(
            file =>
                new Promise((resolve, reject) => {
                    console.log('file===>', file);
                    const formData = new FormData();
                    formData.append('image', file);
                    const stateData = localStorage.getItem('__state');
                    const userData = stateData ? JSON.parse(stateData) : false;
                    const apiUrl = RUN_TIME_API_ENDPOINT;
                    const response = fetch(`${apiUrl}/image_upload_to_s3`, {
                        method: 'POST',
                        body: formData,
                        headers: {
                            'Authorization': userData._token,
                        }
                    }).
                        then(res => res.json()).
                        then(res => {
                            resolve({
                                default: res.url
                            });
                            console.log('res==>', res);
                        });
                })
        );
    }
}

const PromotionCreate = ({ ...props }) => {

    const location = useLocation();
    const pathSplit = location.pathname.split('/');
    const promotionId = pathSplit[2]
    const permissions = usePermissions();
    const navigate = useNavigate();

    const [businessListData, setBusinessListData] = useState([])

    // const businessListData = useGetOne({
    //     // type: 'getList',
    //     resource: `so_business_list`,
    //     payload: { id: 1 }
    // });

    // const businessListData = useGetOne("so_business_list", { id: 1 });

    // const businessData = businessListData && businessListData.data;
    // const originalRetList = businessData && businessData.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() }));
    // const saleOffNameSapCode = businessData && businessData.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() }));

    const [title, setTitle] = useState('');
    const [summary, setSummary] = useState('');
    const [description, setDescription] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [listImage, setListImage] = useState('');
    const [listImageName, setListImageName] = useState('');
    const [detailImage, setDetailImage] = useState('');
    const [detailImageName, setDetailImageName] = useState('');
    const [sendNotification, setSendNotification] = useState(false);
    const [type, setType] = useState();
    // const [originalList, setOriginalList] = useState(originalRetList);
    const [saleOffNameSapCode, setSaleOffNameSapCod] = useState([]);
    const [originalList, setOriginalList] = useState([]);

    const [unregisteredRetailers, setUnregisteredRetailers] = useState([])
    const [pasrsedSimilarDataLength, setPasrsedSimilarDataLength] = useState(0)
    const [pasrsedDifferentDataLength, setPasrsedDifferentDataLength] = useState(0)
    const [unregisteredRetailersToggle, setUnregisteredRetailersToggle] = useState(false)

    const [retailerList, setRetailerList] = useState([])
    const [retailerNameSapCode, setRetailerNameSapCode] = useState([])

    const [listImageSizeError, setListImageSizeError] = useState(false)
    const [listImageTypeError, setListImageTypeError] = useState(false)
    const [detailImageSizeError, setDetailImageSizeError] = useState(false)
    const [detailImageTypeError, setDetailImageTypeError] = useState(false)

    const [loader, setLoader] = useState(false);
    const [showFileError, setShowFileError] = useState(false);

    const maxSize = 1;
    const validImagetypes = ['png', 'gif', 'jpg', 'jpeg'];

    useEffect(() => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        options.method = 'GET';
        fetch(`${apiUrl}/so_business_list`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                console.log('jsonD ===> so_business_list', jsonD)
                let obj = {};
                obj.sap_order_materials = jsonD.data;
                obj.loadingShow = false;
                setBusinessListData(jsonD);
                setOriginalList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })))
                setSaleOffNameSapCod(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })))
                // console.log('obj==>', obj);
                // this.setState({
                //   originalList: obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })),
                //   saleOffNameSapCode: obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })),
                // });
            });
    }, [])

    const handleListFileChange = (e) => {
        setListImageSizeError(false);
        setListImageTypeError(false);
        const file = e.target.files && e.target.files[0];
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
        if (((file.size / 1024 / 1024) > maxSize)) {
            setListImageSizeError(true)
        } else if (validImagetypes.indexOf(fileType.toLowerCase()) > -1) {
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setListImageName(file);
                    setListImage(reader.result)
                };
                reader.readAsDataURL(file);
            }
        } else {
            setListImageTypeError(true)
        }
    };


    const handleDetailFileChange = (e) => {
        setDetailImageSizeError(false);
        setDetailImageTypeError(false);
        const file = e.target.files && e.target.files[0];
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
        if (((file.size / 1024 / 1024) > maxSize)) {
            setDetailImageSizeError(true);
        } else if (validImagetypes.indexOf(fileType.toLowerCase()) > -1) {
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setDetailImageName(file);
                    setDetailImage(reader.result)
                };
                reader.readAsDataURL(file);
            }
        } else {
            setDetailImageTypeError(true);
        }
    };

    const VisitorEditToolbar = props => (
        <Toolbar {...props}>
            <SaveWithNoteButton />
        </Toolbar>
    );

    const SaveWithNoteButton = (props) => {
        console.log('umesh/.......', type);
        const redirectTo = useRedirect();
        const notify = useNotify();
        // const { basePath } = props;
        const resource = useResourceContext();
        let valid = !!title && !!detailImage && !!description && !!listImage && !!startDate && !!endDate && !!type;
        if (type === 'Business') {
            valid = valid && retailerList && retailerList.length > 0
        }
        valid = valid && moment(endDate).format("YYYY-MM-DD") >= moment(startDate).format("YYYY-MM-DD");
        const handleSave = (e) => {
                e.preventDefault();
                setLoader(true);
                const formData = new FormData();
                formData.append('title', title);
                formData.append('summary', summary);
                formData.append('description', description);
                formData.append('detail_image', detailImageName);
                formData.append('preview_image', listImageName);
                formData.append('starts_at', moment(startDate).startOf('day'));
                formData.append('ends_at', moment(endDate).endOf('day'));
                formData.append('type', type);
                formData.append('send_notification', sendNotification);
                formData.append('name_sap_code', JSON.stringify(retailerList));

                const stateData = localStorage.getItem('__state');
                const userData = stateData ? JSON.parse(stateData) : false;
                const options = {};
                const apiUrl = RUN_TIME_API_ENDPOINT;
                options.method = 'POST';

                options.body = formData;
                fetch(`${apiUrl}/promotions`, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Authorization': userData._token,
                    }
                })
                    .then(res => {
                        return res.json();
                    })
                    .then(json => {
                        notify('ra.notification.created', 'info', {
                            smart_count: 1,
                        });
                        setLoader(false);
                        navigate('/promotions');
                        redirectTo('list', resource);
                    }).catch((error) => {
                        console.log('error==>', error);
                    });
                
            };
        // set onSave props instead of handleSubmitWithRedirect
      
        return loader ? <div className="save-loader" /> : <SaveButton onClick={handleSave} label="Save" disabled={!valid} {...props} />;
    };

    const handleChange = e => {
        const arr = [...originalList]

        let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
        if (e === null) {
            result = [...originalList];
        }
        setRetailerList(e);
        setRetailerNameSapCode(result)
    };

    const handleRetailCSVFile = (e) => {
        let file = null;
        file = e.target.files[0];
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
        if (file === null || typeof (file) === 'undefined' || file === '' || typeof (file) === undefined || fileType.toLowerCase() !== 'csv') {
            Swal.fire({
                text: 'Please choose a valid .csv file.',
                confirmButtonText: `OK`,
                icon: 'error'
            });
            file = null;
            console.log('bad file');
        } else {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => {
                    const checkValidHeader = Object.keys(results.data[0]);
                    // console.log('results======>', Object.keys(results.data[0]).includes('COMPANYNAME'));
                    if (checkValidHeader.includes('COMPANYNAME') && checkValidHeader.includes('SAPID')) {
                        const parseddata = permissions.permissions === 'isSap' ?
                            results.data.map((item, i) => ({ id: i, value: item.COMPANYNAME + '-0000' + item.SAPID, label: item.COMPANYNAME + '-0000' + item.SAPID, sap: '0000' + item.SAPID.trim() })) :
                            results.data.map((item, i) => ({ id: i, value: item.COMPANYNAME + ' ' + item.SAPID, label: item.COMPANYNAME + ' ' + item.SAPID, sap: item.SAPID.trim() }));
                        console.log(parseddata);
                        let pasrsedSimilarData = [];
                        pasrsedSimilarData = originalList.filter(a1 => parseddata.some(a2 => a1.sap === a2.sap));
                        if (pasrsedSimilarData && pasrsedSimilarData.length) {
                            const similarArray = retailerList !== null ? retailerList.filter(({ sap: id1 }) =>
                                !pasrsedSimilarData.some(({ sap: id2 }) => id2 === id1)) : [];
                            setRetailerList([...similarArray, ...pasrsedSimilarData]);
                            setPasrsedSimilarDataLength(pasrsedSimilarData.length);
                        }
                        const pasrsedDifferentData = parseddata.filter(a1 => pasrsedSimilarData.every(a2 => a1.sap !== a2.sap));
                        if (pasrsedDifferentData && pasrsedDifferentData.length) {
                            console.log(pasrsedDifferentData, pasrsedDifferentData.length)
                            setUnregisteredRetailers([...pasrsedDifferentData]);
                            setPasrsedDifferentDataLength(pasrsedDifferentData.length);
                        }
                    } else {
                        file = null;
                        Swal.fire({
                            text: 'File headers do not match. Kindly download and refer the sample file.',
                            confirmButtonText: `OK`,
                            icon: 'error'
                        });
                    }
                }
            });
        }
    }

    const cancelClick = (e) => {
        e.preventDefault();
        setRetailerList([]);
        setRetailerNameSapCode(originalList);
        setUnregisteredRetailers([])
        setPasrsedSimilarDataLength(0)
        setPasrsedDifferentDataLength(0)
    }

    return (
        <Create {...props}>
            <TabbedForm className="promotion-createpage" submitOnEnter={false} toolbar={<VisitorEditToolbar />}>
                <FormTab label="① Create">
                    <div className="valid-file-upload">
                        <p>Instructions :</p>
                        <ul>
                            <li>Fill the form on ① Create page. Be sure to select both the images. Selecting the Save and send notification checkbox will save as well as send the targeted retailers a push notification of the promotion</li>
                            <li>Go to ② Preview to see how the promotion will look in LeadRetail app</li>
                            <li>Finally Select your target audience in ③ Send To as either a set of retailers or all retailers in your country. You can even select retailers from a CSV list as long as the CSV is in the given format</li>
                        </ul>
                        <br />
                    </div>
                    <div className="so-input">
                        <label>Promotion Title<sup className="asterisk">*</sup></label>
                        {/* <input
                            type="text"
                            name="Title"
                            value={title}
                            onChange={(e) => { setTitle(e.target.value) }}
                            maxLength={100}
                        /> */}
                        <TextInput className="promotion-title-input" source="title" value={title} onChange={(e) => { setTitle(e.target.value) }} />
                    </div>
                    <div className="upload-promotion-image">
                        <p className="upload-files-label">Promotion List page image<sup className="asterisk">*</sup></p>
                        <input type="file" accept="image/*" onChange={handleListFileChange} />
                        {
                            listImageSizeError &&
                            <div className="so-input-error">File size must be less than 1 MB.</div>
                        }
                        {
                            listImageTypeError &&
                            <div className="so-input-error">File type must include .jpg, .jpeg, .png, .gif</div>
                        }
                    </div>
                    <div className="valid-file-upload">
                        <p>Instructions :</p>
                        <ul>
                            <li>Allowed file types: Images: JPG Image, JPEG Image, PNG Image, GIF</li>
                            <li>Max file size (total): 1 MB</li>
                            <li>Image dimensions: 360 pixels in width & 184 pixels in height</li>
                        </ul>
                    </div>
                    <div className="promotion-text-editor">
                        <p className="upload-files-label"> List Page Text </p>
                        <CKEditor
                            editor={ClassicEditor}
                            data={summary}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                console.log("asadaasas", data)
                                setSummary(data);
                            }}
                            onInit={editor => {
                                editor.editing.view.change(writer => {
                                    writer.setStyle(
                                        "min-height",
                                        "200px",
                                        editor.editing.view.document.getRoot()
                                    );
                                });
                            }}
                        />
                    </div>
                    <div className="upload-promotion-image">
                        <p className="upload-files-label">Promotion Notification Homepage Popup image<sup className="asterisk">*</sup></p>
                        <input type="file" accept="image/*" onChange={handleDetailFileChange} />
                        {
                            detailImageSizeError &&
                            <div className="so-input-error">File size must be less than 1 MB.</div>
                        }
                        {
                            detailImageTypeError &&
                            <div className="so-input-error">File type must include .jpg, .jpeg, .png, .gif</div>
                        }
                    </div>
                    <div className="valid-file-upload">
                        <p>Instructions :</p>
                        <ul>
                            <li>Allowed file types: Images: JPG Image, JPEG Image, PNG Image, GIF</li>
                            <li>Max file size (total): 1 MB</li>
                            <li>Image dimensions: 640 pixels in width & 918 pixels in height</li>
                        </ul>
                    </div>
                    {/* {JSON.stringify(description)} */}
                    <div className="promotion-text-editor">
                        <p className="upload-files-label"> Detail Page Text<sup className="asterisk">*</sup> </p>
                        <CKEditor
                            editor={ClassicEditor}
                            data={description}
                            onInit={editor => {
                                editor.plugins.get("FileRepository").createUploadAdapter = loader => {
                                    return new MyUploadAdapter(loader);
                                };
                                editor.editing.view.change(writer => {
                                    writer.setStyle(
                                        "min-height",
                                        "200px",
                                        editor.editing.view.document.getRoot()
                                    );
                                });
                            }}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setDescription(data);
                            }}
                        />
                    </div>
                    <div className="promotion-date">
                        <div>
                            <p className="upload-files-label">Start Date<sup className="asterisk">*</sup></p>
                            {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
                                <DatePicker
                                    value={startDate}
                                    onChange={e => setStartDate(e)}
                                    format="dd/MM/yyyy"
                                    minDate={new Date()}
                                // maxDate={endDate}
                                />
                            {/* </LocalizationProvider> */}
                        </div>
                        <div>
                            <p className="upload-files-label">End Date<sup className="asterisk">*</sup></p>
                            {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
                                <DatePicker

                                    value={endDate}
                                    onChange={e => setEndDate(e)}
                                    format="dd/MM/yyyy"
                                    minDate={startDate}
                                // maxDate={this.state.toDate}
                                />
                            {/* </LocalizationProvider> */}
                        </div>
                    </div>
                    {
                        moment(new Date()).format("YYYY-MM-DD") >= moment(startDate).format("YYYY-MM-DD") &&
                        <label className="promotion-send-check">
                            <input type="checkbox"
                                checked={sendNotification}
                                onChange={() => { setSendNotification(!sendNotification) }}
                            />
                            Save and send notification
                        </label>
                    }


                </FormTab>
                <FormTab label="② Preview">
                    {/* <div className="promotion-preview-heading">Promotion Notification Popup</div>
                    <div className="promotion-popup-page-preview">
                        <div className="promotion-popup-preview">
                            <div className="lr-onboarding__close">
                                <span className="icon-close" />
                            </div>
                            <div className="lr-loyalty__schemes__row__description">
                                <div>
                                    <img src={detailImage} />
                                </div>
                            </div>
                            <button className="preview-page-btn"><span>View</span></button>
                        </div>
                    </div> */}
                    <div className="promotion-preview-heading">Promotion List page</div>
                    <div className="promotion-page-preview no-m-auto">
                        <div className="lr-main-view__header">
                            <span className="icon-back" />
                            <span className="preview-page-header">Promotions</span>
                        </div>
                        <div className="promotion-card">
                        <div className="lr-loyalty__schemes__row_image">
                            <img src={listImage} />
                        </div>
                        <div className="lr-loyalty__schemes__row__heading">{title}</div>
                        </div>
                        {/* <div className="lr-loyalty__schemes__row__description" dangerouslySetInnerHTML={{ __html: summary }}>
                             Rendering html dynamically
                        </div> */}
                        {/* <button className="preview-page-btn"><span>Know More</span></button> */}
                    </div>
                    <div className="promotion-preview-heading">Promotion Detail page</div>
                    <div className="promotion-page-preview no-m-auto">
                        <div className="lr-main-view__header">
                            <span className="icon-back" />
                            <span className="preview-page-header">Promotion Detail</span>
                        </div>
                        <div className="lr-loyalty__schemes__row__heading">{title}</div>
                        <div className="lr-loyalty__schemes__row__description">
                            <div>
                                <img src={detailImage} />
                            </div>
                            {/* <div dangerouslySetInnerHTML={{ __html: description }}>
                                Rendering html dynamically 
                            </div> */}
                        </div>
                    </div>
                </FormTab>
                <FormTab label="③ Send To">
                    <div className="so-input">
                        <label>Notification Send To<sup className="asterisk">*</sup></label>
                        <select className="inapp-notification-sendto" name="type" value={type} onChange={(e) => { setType(e.target.value) }}>
                            <option value="">Select Option</option>
                            <option value="Country">All Retailers</option>
                            <option value="Business">A set of Retailers</option>
                        </select>
                    </div>
                    {
                        type === 'Business' &&
                        <div>
                            <div className="csv-file-upload-container target-upload-container"><label>Upload File</label>
                                {/* <input type="file" accept=".csv" name="flies[]" /> */}
                                <input type="file" id="file" accept=".csv" onChange={handleRetailCSVFile} />
                                {showFileError && <p className="complaint-file-error" >Choose Valid file</p>}
                                <div className="valid-file-upload">
                                    <p>Instructions :</p>
                                    <ul>
                                        <li>Only CSV files are allowed with Comma as separator.</li>
                                    </ul>
                                </div>
                                <div className="upload-file-format-download">
                                    <p>To get upload file format. <a
                                        href="https://navendor-global-production.s3-eu-west-1.amazonaws.com/infographics/sample.csv"
                                        target="_blank">Click here</a> to download</p>
                                </div>
                            </div>
                            <div>
                                {
                                    pasrsedSimilarDataLength > 0 ||
                                        pasrsedDifferentDataLength > 0 ?
                                        <div className="csv-result-container">
                                            <label>CSV Result</label>
                                            <div className="csv-result">
                                                <div>
                                                    <p onClick={() => setUnregisteredRetailersToggle(!unregisteredRetailersToggle)}>
                                                        {pasrsedSimilarDataLength} retailers found, {pasrsedDifferentDataLength} retailers unregistered.
                                                    {pasrsedDifferentDataLength > 0 ? ' Click to view unregistererd retailers' : ''}
                                                        {
                                                            pasrsedDifferentDataLength > 0 ?
                                                                <span className={unregisteredRetailersToggle ? `icon-arrow_down` : `icon-arrow_up`} />
                                                                : ''
                                                        }
                                                    </p>
                                                    {
                                                        pasrsedDifferentDataLength > 0 ?
                                                            <div className={unregisteredRetailersToggle ? `hide-unregistered` : `show-unregistered`}>
                                                                <React.Fragment>
                                                                    {
                                                                        unregisteredRetailers.map(item => (
                                                                            <p key={item.id}>{item.label}</p>
                                                                        ))
                                                                    }
                                                                </React.Fragment>
                                                            </div>
                                                            : ''
                                                    }
                                                </div>
                                            </div>
                                        </div> :
                                        ''
                                }
                            </div>
                            <label className="select-label">Choose Retailers<sup className="asterisk">*</sup> (Atleast select one retailer)</label>
                            <div className="select-retailer">
                                <Select
                                    value={retailerList}
                                    onChange={handleChange}
                                    options={saleOffNameSapCode}
                                    isMulti
                                />
                                <button onClick={e => cancelClick(e)}>Clear</button>
                            </div>
                        </div>

                    }
                </FormTab>
                {/* <SaveWithNoteButton /> */}
            </TabbedForm>
        </Create>
    )
};

export default PromotionCreate;